import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"
 
const InvoicedOrders: React.SFC = () => {
    return (  
        <OrdersLayout/>
    );
}
 
export default InvoicedOrders;